import React, { useEffect, useMemo, useState } from "react";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import closeIcon from "../../../../assets/closeModel.png";
import checkedIcon from "../../../../assets/check-mark.png";
import deleteIcon from "../../../../assets/trash.png";
import { DialogContent, DialogContentText, Grid } from "@mui/material";
import Notification from "../../../../components/common/notification/Notification";
import FormField from "../../../../components/common/FormField";
import { useDispatch } from "react-redux";
import Validation from "../../../../utils/Validation";

import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import ResetFormAlert from "../../../../components/common/ResetFormAlert";
import { REVIEW_FIELDS, validateReviewForm } from "./allFieldsUtil";
import {
  addReviewAction,
  getAllReviwSourceAction,
  intialReviewLocalState,
} from "../../../../store/reducers/reviewSlice";
import { useSelector } from "react-redux";
import { getCompleteWorkDiaryAction } from "../../../../store/reducers/workDiarySlice";
interface ManagePopupProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectedData: any; // Adjust type as per your requirement
  isSmallScreen?: boolean; //
  action?: string;
  activeQuoteId?: any;
}

const ManageReview = (props: ManagePopupProps) => {
  const classes = useStyles();
  const {
    selectedData,
    onHide,
    open,
    title,
    action,
    isSmallScreen,
    activeQuoteId,
  } = props;
  const [formData, setFormData] = useState<any>(intialReviewLocalState);
  const { userProfile } = useSelector((state: any) => state.user);
  const { leadDetails } = useSelector((state: any) => state.lead);
  const { completeWorkDiaryData } = useSelector(
    (state: any) => state?.workDiary,
  );
  const leadId =
    selectedData?.lead_id ||
    formData?.lead_id ||
    leadDetails?.lead?.generated_id ||
    "";
  const dispatch = useDispatch();
  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);
  const { reviewSource } = useSelector((state: any) => state.review);
  const [fieldErrors, setFieldErrors] = useState<any>({});
  const [, checkValidator]: any = Validation({
    source_id: formData?.source_id,
    date: formData?.date,
    job_name: formData?.job_name,
    rating_title: formData?.rating_title,
    obtained_from: formData?.obtained_from,
    status: formData?.status,
  });

  useEffect(() => {
    setFormData((prev: any) => ({
      ...prev,
      lead_id:
        prev?.lead_id || selectedData?.lead_id || leadDetails?.lead?.generated_id || "",
      quote_id: activeQuoteId?.quoteId ?? prev?.quote_id ?? null,
    }));
  }, [leadDetails, activeQuoteId, selectedData?.lead_id]);

  useEffect(() => {
    if (selectedData) {
      const isGeneral =
        selectedData?.job_id === null &&
        selectedData?.job_name === "General";
      setFormData({
        ...selectedData,
        job_id: isGeneral
          ? "General"
          : selectedData?.job_id || "",
        job_name: selectedData?.job_name || "",
        lead_id: selectedData?.lead_id || "",
        quote_id: selectedData?.quote_id ?? activeQuoteId?.quoteId ?? null,
      });
    }
  }, [selectedData, activeQuoteId?.quoteId]);

  useEffect(() => {
    if (!open) return;

    dispatch(getAllReviwSourceAction());

    if (leadId) {
      dispatch(
        getCompleteWorkDiaryAction({
          search: "",
          leadId,
        }),
      );
    }
  }, [dispatch, leadId, open]);

  const fieldsToRender = useMemo(() => {
    const sourceOptions = (reviewSource || []).map((item: any) => ({
      id: item?.id,
      label: item?.name,
    }));

    const allTasks = (completeWorkDiaryData || []).flatMap(
      (item: any) => item.tasks || [],
    );

    const uniqueJobOptions: Array<{ id: string; label: string }> = [];
    const seenJobIds = new Set<string>();

    allTasks.forEach((task: any) => {
      const id = String(task?.job_id ?? "").trim();
      const label = String(task?.job_title ?? "").trim();
      if (!id || !label || seenJobIds.has(id)) return;
      seenJobIds.add(id);
      uniqueJobOptions.push({ id, label });
    });

    return REVIEW_FIELDS.map((field) => {
      if (field.id === "source_id") {
        return {
          ...field,
          options: sourceOptions,
          type: "select",
        };
      }

      if (field.id === "job_id") {
        return {
          ...field,
          options: [{ label: "General", id: "General" }, ...uniqueJobOptions],
        };
      }

      return field;
    });
  }, [reviewSource, completeWorkDiaryData]);

  const hideHandler = () => {
    onHide();
    setFieldErrors({});
  };

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();

    const errors = validateReviewForm(formData, fieldsToRender);

    setFieldErrors(errors);

    if (Object.keys(errors).length > 0) {
      return;
    }

    if (action === "edit" && selectedData?.id) {
      const { id, updated_by, updated_at, created_at, created_by, ...rest } =
        formData;
      dispatch(addReviewAction({ ...rest, id: selectedData?.id }));
      return;
    }

    dispatch(addReviewAction(formData));
  };

  const handleInputChange = (field: string, value: any) => {
    if (field === "job_id") {
      const jobField = fieldsToRender.find((f) => f.id === "job_id");

      const selectedOption = (jobField?.options as any[])?.find(
        (opt: any) => opt.id === value,
      );

      if (value === "General") {
        setFormData((prev: any) => ({
          ...prev,
          job_id: null,
          job_name: "General",
        }));
      } else {
        setFormData((prev: any) => ({
          ...prev,
          job_id: value,
          job_name: selectedOption?.label || "",
        }));
      }

      setFieldErrors((prev: any) => ({
        ...prev,
        job_id: false,
      }));

      return;
    }

    setFormData((prev: any) => ({
      ...prev,
      [field]: value,
    }));

    setFieldErrors((prev: any) => ({
      ...prev,
      [field]: false,
    }));
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };

  const handleClear = () => {
    if (selectedData?.id && action === "edit") {
      setFormData({ ...selectedData });
    } else {
      setFormData(intialReviewLocalState);
    }

    setFieldErrors({});
    setIsClickReset(false);
  };

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setAlertModelShow(false);
    }
  }, [isClickReset]);

  return (
    <>
      <Popup
        open={open}
        title={title}
        onHide={hideHandler}
        fullWidth={true}
        maxWidth={"md"}
        aria-describedby="alert-dialog-slide-description"
        popupBg="#fff"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent sx={{ padding: "16px 10px !important" }}>
          <DialogContentText>
            <>
              <Notification />
              <Grid
                container
                direction="row"
                spacing={0.5}
                rowGap={0}
                rowSpacing={0}
                sx={{
                  background: "#E5F4F1",
                  padding: "10px !important",
                  marginTop: "10px !important",
                  borderRadius: "5px",
                  border: "1px solid #CFCFCF",
                  overflow: "hidden",
                }}
              >
                {fieldsToRender.map((field, i) => {
                  return (
                    <FormField
                      // onPaste={(e) =>
                      //   field?.id === "title" ? "" : e.preventDefault()
                      // }
                      onKeyDown={(event: any) => {
                        console.log(
                          "event log-",
                          event,
                          event.target.value + event.key,
                        );
                        if (
                          event.keyCode === 8 ||
                          event.keyCode === 9 ||
                          event.keyCode === 37 ||
                          event.keyCode === 38 ||
                          event.keyCode === 39 ||
                          event.keyCode === 40 ||
                          event.keyCode === 18 ||
                          event.keyCode === 17 ||
                          event.ctrlKey
                        )
                          return event;
                        if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(event.key)
                        ) {
                          event.preventDefault();
                        } else if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(
                            event.target.value + event.key,
                          )
                        ) {
                          event.preventDefault();
                        }
                      }}
                      {...{
                        ...field,
                        ...{
                          variant: "outlined", // Adding this variant prop
                          inSingleGridForm: true,
                          isNonMarginTop: true,
                          InputProps: {
                            ...(field?.inputProps && field?.inputProps),
                            sx: {
                              height:
                                field?.id === "notes" &&
                                formData[field?.id]?.length > 36
                                  ? "auto"
                                  : "36px",
                              padding: field?.id === "notes" ? "4px" : "",
                            },
                            // ...(selectUser && { disabled: field?.editReadOnly }),
                            autocomplete: "user-new-field",
                          },

                          value: formData ? formData[field.id] : "",
                          onBlur: onBlurAction,
                          // selectedValues: materialDetail[field?.id],
                          onChange: (e: any) =>
                            handleInputChange(field.id, e.target.value), // Call onChange prop
                          error: fieldErrors[field?.id] || false,
                        },
                      }}
                    />
                  );
                })}
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
};
export default ManageReview;
